<template>
  <b-card>
    <b-row :key="'filter-params-' + filterResetKey">
      <div
        class="col-md-4 col-sm-6"
        v-for="param in visibleParams"
        v-bind:key="param.field"
      >
        <b-form-group :label="param.label">
          <NumberSeprator
            v-if="param.type === 'number'"
            v-model="param.value"
          ></NumberSeprator>
          <b-form-input
            v-if="param.type === 'text'"
            type="text"
            v-model="param.value"
          ></b-form-input>
          <v-select
            v-if="param.type === 'select' && param.multiple === true"
            v-model="param.value"
            :items="getParamOptions(param)"
            item-text="text"
            item-value="value"
            multiple
            attach
            clearable
            hide-details
            outlined
            dense
            @keydown.native="preventSelectTyping"
            @paste.native.prevent
          ></v-select>
          <b-form-select
            v-if="param.type === 'select' && param.multiple !== true"
            v-model="param.value"
            :options="getParamOptions(param)"
          ></b-form-select>
        </b-form-group>
      </div>
    </b-row>
    <b-row class="mb-3" :key="'filter-dates-' + filterResetKey">
      <b-col cols="12" md="4">
        <b-form-group label="تاریخ و ساعت">
          <b-form-select
            :value="getParamValue('dateRange')"
            :options="dateRangeSelectOptions"
            @change="onDateRangeChange"
          ></b-form-select>
        </b-form-group>
      </b-col>
      <b-col v-if="getParamValue('dateRange') === 'custom'" md="4" sm="6">
        <b-form-group label="تاریخ شروع">
          <date-picker clearable v-model="customFromDate"></date-picker>
        </b-form-group>
      </b-col>
      <b-col v-if="getParamValue('dateRange') === 'custom'" md="4" sm="6">
        <b-form-group label="تاریخ پایان">
          <date-picker clearable v-model="customToDate"></date-picker>
        </b-form-group>
      </b-col>
    </b-row>
    <b-row>
      <b-col cols="6" md="2" sm="6">
        <b-button
          @click="loadData(1)"
          variant="success"
          block
          :class="isBusy ? 'spinner spinner-light spinner-right' : ''"
          >جستجو</b-button
        >
      </b-col>
      <b-col cols="6" md="2" sm="6">
        <b-button
          @click="exportExcel"
          variant="danger"
          block
          :disabled="isExporting"
          :class="isExporting ? 'spinner spinner-light spinner-right' : ''"
          >دریافت فایل اکسل</b-button
        >
      </b-col>
      <b-col cols="6" md="2" sm="6">
        <b-button variant="secondary" block @click="clearFilters"
          >پاک کردن فیلترها</b-button
        >
      </b-col>
    </b-row>

    <div v-if="!dataLoaded" class="pt-5 pb-5">
      <b-skeleton-table
        :rows="5"
        :columns="8"
        :table-props="{ bordered: true, striped: true }"
      ></b-skeleton-table>
    </div>
    <div v-else>
      <b-table
        responsive
        :busy="isBusy"
        style="width: 100%"
        striped
        hover
        show-empty
        empty-text="آیتمی جهت نمایش وجود ندارد"
        :items="transfers"
        :fields="fields"
      >
        <template #cell(id)="row">
          <copyable-table-cell :value="row.item.id" :label="row.field.label" />
        </template>
        <template #cell(destinationIban)="row">
          <copyable-table-cell
            :value="row.item.destinationIban"
            :label="row.field.label"
          />
        </template>
        <template #cell(actions)="row">
          <b-button
            variant="link"
            class="p-0 transfer-action-btn"
            v-b-tooltip.hover
            title="مشاهده جزئیات"
            @click="openTransferDetails(row.item)"
          >
            <b-icon icon="eye" font-scale="1.1"></b-icon>
          </b-button>
        </template>
      </b-table>
    </div>

    <b-modal
      v-model="showDetailModal"
      hide-footer
      title="جزئیات تراکنش"
      centered
      size="lg"
      @hidden="selectedTransfer = null"
    >
      <div v-if="selectedTransfer">
        <div class="mb-3 text-center">
          <b-badge :variant="selectedTransferStatus.variant" pill>
            {{ selectedTransferStatus.label }}
          </b-badge>
        </div>
        <div class="simple-detail-list">
          <div
            v-for="row in transferDetailRows"
            :key="row.label"
            class="simple-detail-row"
          >
            <span class="simple-detail-label">{{ row.label }}</span>
            <span class="simple-detail-value" :class="row.valueClass">{{
              row.value
            }}</span>
          </div>
        </div>
      </div>
    </b-modal>

    <div class="row" v-if="page_count > 1">
      <b-button-group>
        <b-button @click="loadData(1)"><i class="flaticon2-next"></i></b-button>
        <b-button
          v-for="page in pages"
          v-bind:key="page"
          @click="loadData(page)"
          :variant="page === current_page ? 'success' : 'default'"
          >{{ page }}</b-button
        >
        <b-button @click="loadData(page_count)"
          ><i class="flaticon2-back"></i
        ></b-button>
      </b-button-group>
      <b-input-group class="ml-3 w-150 mt-4 mt-md-0">
        <b-input-group-prepend>
          <b-button @click="loadData(Number(pageNumber) || 1)" variant="success"
            >برو به صفحه</b-button
          >
        </b-input-group-prepend>
        <b-form-input
          :formatter="toEnglishNumbers"
          v-model="pageNumber"
        ></b-form-input>
      </b-input-group>
    </div>
  </b-card>
</template>

<script>
import httpHelper from "../helpers/httpHelper";
import NumberSeprator from "./numberSeprator";
import CopyableTableCell from "./CopyableTableCell";
import ReplaceNumber from "@/mixins/ReplaceNumber";
import moment from "jalali-moment";
import { EMPTY_VALUE } from "../helpers/copyableHelper";
import { getReasonDescriptionLabel } from "../helpers/reasonDescriptionHelper";

const STATUS_LABELS = {
  SUCCESS: "موفق",
  FAILED: "ناموفق",
  PENDING: "در دست بررسی",
  PREFAILED: "در حال تلاش مجدد",
};

const STATUS_CLASSES = {
  SUCCESS: "text-success",
  FAILED: "text-danger",
  PENDING: "text-warning",
  PREFAILED: "text-info",
};

const STATUS_ICONS = {
  SUCCESS: "check-circle-fill",
  FAILED: "x-circle-fill",
  PENDING: "hourglass-split",
  PREFAILED: "arrow-repeat",
};

export default {
  name: "TransfersTable",
  mixins: [ReplaceNumber],
  components: {
    NumberSeprator,
    CopyableTableCell,
  },
  props: {
    gatewayId: {
      type: [String, Number],
      default: null,
    },
    pageSize: {
      type: Number,
      default: 10,
    },
    banksMap: {
      type: Object,
      default: () => ({}),
    },
    bankOptions: {
      type: Array,
      default: () => [],
    },
    bankProviders: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      useMockData: false,
      filterResetKey: 0,
      isBusy: false,
      isExporting: false,
      dataLoaded: false,
      transfers: [],
      pages: [],
      current_page: 1,
      page_count: 0,
      pageNumber: 1,
      showDetailModal: false,
      selectedTransfer: null,
      fields: [
        {
          key: "transferCreatedAt",
          label: "تاریخ و ساعت ثبت",
          formatter: (value, key, item) => {
            if (!item.createdAt) return EMPTY_VALUE;

            const date = moment(item.createdAt);
            return date.isValid()
              ? date.format("jYYYY/jMM/jDD | HH:mm:ss")
              : item.createdAt;
          },
          tdClass: "ltr-dir",
        },
        {
          key: "id",
          label: "شناسه Transfer",
          formatter: (value) => value || EMPTY_VALUE,
        },
        {
          key: "amount",
          label: "مبلغ (ریال)",
          formatter: (value) => {
            if (value == null || value === "") return EMPTY_VALUE;

            const numericValue = Number(value);
            return Number.isFinite(numericValue)
              ? numericValue.toLocaleString()
              : String(value);
          },
          tdClass: "ltr",
        },
        {
          key: "destinationIban",
          label: "شماره شبا مقصد",
          formatter: (value) => value || EMPTY_VALUE,
          tdClass: "ltr-dir",
        },
        {
          key: "destinationFirstName",
          label: "نام گیرنده",
          formatter: (value, key, item) => {
            const fullName = [
              item.destinationFirstName,
              item.destinationLastName,
            ]
              .filter(Boolean)
              .join(" ")
              .trim();

            return fullName || EMPTY_VALUE;
          },
        },
        {
          key: "provider",
          label: "حساب مبدأ",
          formatter: (value, key, item) => this.formatSourceAccount(item),
        },
        {
          key: "status",
          label: "وضعیت",
          formatter: (value, key, item) => {
            const status = String(
              item.status || item.state || "",
            ).toUpperCase();
            return STATUS_LABELS[status] || value || EMPTY_VALUE;
          },
          tdClass: (value, key, item) =>
            STATUS_CLASSES[
              String(item.status || item.state || "").toUpperCase()
            ] || "",
        },
        {
          key: "bankTrackingNumber",
          label: "کد رهگیری",
          formatter: (value) => value || EMPTY_VALUE,
        },
        {
          key: "actions",
          label: "عملیات",
          thClass: "text-center",
          tdClass: "text-center",
        },
      ],
      dateRangeOptions: [
        { text: "امروز", value: "today" },
        { text: "روز گذشته", value: "yesterday" },
        { text: "۷ روز گذشته", value: "7days" },
        { text: "۳۰ روز گذشته", value: "30days" },
        { text: "۶۰ روز گذشته", value: "60days" },
        { text: "یک سال گذشته", value: "1year" },
        { text: "بازه زمانی دلخواه", value: "custom" },
      ],
      params: [
        {
          label: "مبلغ از",
          field: "minAmount",
          type: "number",
          value: null,
        },
        {
          label: "مبلغ تا",
          field: "maxAmount",
          type: "number",
          value: null,
        },
        {
          label: "شماره شبا",
          field: "destinationIban",
          type: "text",
          value: null,
        },
        {
          label: "شناسه واریز",
          field: "paymentId",
          type: "text",
          value: null,
        },
        {
          label: "کد رهگیری",
          field: "orderId",
          type: "text",
          value: null,
        },
        {
          label: "وضعیت",
          field: "status",
          type: "select",
          value: null,
          options: [
            { text: "انتخاب وضعیت", value: null },
            { text: "موفق", value: "SUCCESS" },
            { text: "ناموفق", value: "FAILED" },
            { text: "در دست بررسی", value: "PENDING" },
            { text: "در حال تلاش مجدد", value: "PREFAILED" },
          ],
        },
        {
          label: "نام بانک ها",
          field: "sourceBankName",
          type: "select",
          value: null,
        },
        {
          label: "نام صاحب حساب / نام گیرنده",
          field: "name",
          type: "text",
          value: null,
        },
        {
          label: "حساب مبدأ",
          field: "providerNicknames",
          type: "select",
          value: [],
          multiple: true,
        },
        { field: "dateRange", value: null },
        { field: "customFromDate", value: null },
        { field: "customToDate", value: null },
      ],
    };
  },
  computed: {
    visibleParams() {
      const hidden = new Set(["dateRange", "customFromDate", "customToDate"]);
      return this.params.filter((p) => {
        if (!p.type || hidden.has(p.field)) return false;
        return true;
      });
    },
    providerOptions() {
      return this.bankProviders
        .filter((p) => p.isActive !== false && p.nickname)
        .map((provider) => ({
          text: `${provider.label} - (${provider.accountNumber})`,
          value: provider.nickname,
        }));
    },
    dateRangeSelectOptions() {
      return [
        { text: "انتخاب بازه زمانی", value: null },
        ...this.dateRangeOptions,
      ];
    },
    customFromDate: {
      get() {
        return this.getParamValue("customFromDate");
      },
      set(value) {
        this.setParamValue("customFromDate", value);
      },
    },
    customToDate: {
      get() {
        return this.getParamValue("customToDate");
      },
      set(value) {
        this.setParamValue("customToDate", value);
      },
    },
    selectedTransferStatus() {
      const status = this.getTransferStatus(this.selectedTransfer);
      return {
        label: STATUS_LABELS[status] || status || EMPTY_VALUE,
        icon: STATUS_ICONS[status] || "question-circle",
        className: STATUS_CLASSES[status] || "",
        variant: this.getStatusVariant(status),
      };
    },
    transferDetailRows() {
      if (!this.selectedTransfer) return [];

      const item = this.selectedTransfer;
      return [
        {
          label: "مبلغ (ریال)",
          value: this.formatDetailAmount(item.amount),
          valueClass: "ltr-dir",
        },
        {
          label: "تاریخ و زمان",
          value: this.formatDetailDateTime(item.createdAt),
          valueClass: "ltr-dir",
        },
        {
          label: "نام و نام خانوادگی",
          value: this.formatDetailFullName(item),
        },
        {
          label: "کد رهگیری",
          value: this.formatDetailValue(item.bankTrackingNumber),
        },
        {
          label: "شناسه سفارش",
          value: this.formatDetailValue(item.orderId),
        },
        {
          label: "شناسه واریز",
          value: this.formatDetailValue(item.paymentId),
        },
        {
          label: "بانک مبدا",
          value: this.formatDetailSourceBank(item),
        },
        {
          label: "بانک مقصد",
          value: this.formatDetailDestinationBank(item),
        },
        {
          label: "بابت",
          value: this.formatDetailReason(item.reasonDescription),
        },
        {
          label: "توضیحات",
          value: this.formatDetailValue(item.transactionDescription),
        },
        {
          label: "کارمزد بانک",
          value: this.formatDetailAmount(item.bankWage),
          valueClass: "ltr-dir",
        },
        {
          label: "شناسه Transfer",
          value: this.formatDetailValue(item.id),
        },
        {
          label: "شماره شبا مقصد",
          value: this.formatDetailValue(item.destinationIban),
          valueClass: "ltr-dir",
        },
        {
          label: "شماره شبا مبدأ",
          value: item.sourceIban,
        },
      ];
    },
  },
  methods: {
    getParamOptions(param) {
      if (param.field === "sourceBankName") return this.bankOptions;
      if (param.field === "providerNicknames") return this.providerOptions;
      return param.options || [];
    },
    getParamValue(field) {
      const p = this.params.find((x) => x.field === field);
      return p ? p.value : null;
    },
    setParamValue(field, value) {
      const p = this.params.find((x) => x.field === field);
      if (p) p.value = value;
    },
    onDateRangeChange(value) {
      this.setParamValue("dateRange", value);
      if (value !== "custom") {
        this.setParamValue("customFromDate", null);
        this.setParamValue("customToDate", null);
      }
    },
    getTransferStatus(item) {
      if (!item) return "";
      return String(item.status || item.state || "").toUpperCase();
    },
    getStatusVariant(status) {
      const variants = {
        SUCCESS: "success",
        FAILED: "danger",
        PENDING: "warning",
        PREFAILED: "info",
      };
      return variants[status] || "secondary";
    },
    formatDetailValue(value) {
      if (value == null || value === "") return EMPTY_VALUE;
      return String(value);
    },
    formatDetailAmount(value) {
      if (value == null || value === "") return EMPTY_VALUE;

      const numericValue = Number(value);
      return Number.isFinite(numericValue)
        ? `ریال ${numericValue.toLocaleString()}`
        : String(value);
    },
    formatDetailDateTime(value) {
      if (!value) return EMPTY_VALUE;

      const date = moment(value);
      return date.isValid()
        ? date.format("jYYYY/jMM/jDD , HH:mm:ss")
        : String(value);
    },
    formatDetailFullName(item) {
      const fullName = [
        item.destinationFirstNameInput,
        item.destinationLastNameInput,
      ]
        .filter(Boolean)
        .join(" ")
        .trim();

      return fullName || EMPTY_VALUE;
    },
    formatDetailReason(value) {
      return getReasonDescriptionLabel(value) ?? EMPTY_VALUE;
    },
    formatDetailSourceBank(item) {
      if (item.sourceBank) {
        return (
          this.banksMap[item.sourceBank] ||
          this.formatDetailValue(item.sourceBank)
        );
      }
      return EMPTY_VALUE;
    },
    formatDetailDestinationBank(item) {
      if (!item.destinationBankInput) return EMPTY_VALUE;
      return (
        this.banksMap[item.destinationBankInput] ||
        this.formatDetailValue(item.destinationBankInput)
      );
    },
    formatSourceAccount(item) {
      const bankName = item.sourceBank
        ? this.banksMap[item.sourceBank] || item.sourceBank
        : "";
      const digits = item.sourceIban
        ? this.fixNumbers(item.sourceIban).replace(/\D/g, "").slice(0, 4)
        : "";
      const masked =
        digits.length === 4
          ? `(${digits.replace(/\d/g, (d) => "۰۱۲۳۴۵۶۷۸۹"[d])}....)`
          : "";

      return [bankName, masked].filter(Boolean).join(" ") || EMPTY_VALUE;
    },
    openTransferDetails(item) {
      this.selectedTransfer = item;
      this.showDetailModal = true;
    },
    closeTransferDetails() {
      this.selectedTransfer = null;
      this.showDetailModal = false;
    },
    preventSelectTyping(event) {
      const allowedKeys = [
        "Tab",
        "Escape",
        "Enter",
        "ArrowUp",
        "ArrowDown",
        "ArrowLeft",
        "ArrowRight",
        "Backspace",
        "Delete",
      ];

      if (
        event.ctrlKey ||
        event.metaKey ||
        event.altKey ||
        allowedKeys.includes(event.key)
      ) {
        return;
      }

      if (event.key && event.key.length === 1) {
        event.preventDefault();
      }
    },
    toEnglishNumbers(value) {
      const p2e = (s) =>
        String(s).replace(/[۰-۹]/g, (d) => "۰۱۲۳۴۵۶۷۸۹".indexOf(d));
      return p2e(value);
    },
    parseDateValue(val) {
      if (!val) return null;
      let m = moment(val, "jYYYY/jMM/jDD", true);
      if (!m.isValid()) m = moment(val, "jYYYY-jMM-jDD", true);
      if (!m.isValid()) m = moment(val);
      return m.isValid() ? m.toISOString() : null;
    },
    computeDateRange(option) {
      const now = moment();
      switch (option) {
        case "today":
          return {
            fromDate: now.clone().startOf("day").toISOString(),
            toDate: now.clone().endOf("day").toISOString(),
          };
        case "yesterday":
          return {
            fromDate: now
              .clone()
              .subtract(1, "day")
              .startOf("day")
              .toISOString(),
            toDate: now.clone().subtract(1, "day").endOf("day").toISOString(),
          };
        case "7days":
          return {
            fromDate: now.clone().subtract(7, "days").toISOString(),
            toDate: now.toISOString(),
          };
        case "30days":
          return {
            fromDate: now.clone().subtract(30, "days").toISOString(),
            toDate: now.toISOString(),
          };
        case "60days":
          return {
            fromDate: now.clone().subtract(60, "days").toISOString(),
            toDate: now.toISOString(),
          };
        case "1year":
          return {
            fromDate: now.clone().subtract(1, "year").toISOString(),
            toDate: now.toISOString(),
          };
        default:
          return { fromDate: null, toDate: null };
      }
    },
    getQueryField(field) {
      if (field === "providerNicknames") return "nickname";
      return field;
    },
    buildQuery(page, withPagination = true) {
      const parts = withPagination
        ? [`page=${page}`, `pageSize=${this.pageSize}`]
        : [];
      this.params.forEach((p) => {
        const queryField = this.getQueryField(p.field);

        if (Array.isArray(p.value)) {
          const values = p.value
            .map((value) => this.fixNumbers(value))
            .filter((value) => value != null && value !== "");

          values.forEach((value) => {
            parts.push(`${queryField}=${encodeURIComponent(value)}`);
          });
          return;
        }

        const v = this.fixNumbers(p.value);
        if (v == null || v === "") return;

        if (p.field === "dateRange") {
          if (v === "custom") {
            const from = this.parseDateValue(
              this.getParamValue("customFromDate"),
            );
            const to = this.parseDateValue(this.getParamValue("customToDate"));
            if (from) parts.push(`fromDate=${encodeURIComponent(from)}`);
            if (to) parts.push(`toDate=${encodeURIComponent(to)}`);
          } else {
            const range = this.computeDateRange(v);
            if (range.fromDate) {
              parts.push(`fromDate=${encodeURIComponent(range.fromDate)}`);
            }
            if (range.toDate) {
              parts.push(`toDate=${encodeURIComponent(range.toDate)}`);
            }
          }
          return;
        }

        if (p.field === "customFromDate" || p.field === "customToDate") return;

        parts.push(`${queryField}=${encodeURIComponent(v)}`);
      });
      return parts.join("&");
    },
    downloadBlob(blob, filename) {
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", filename);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);
    },
    exportExcel() {
      const query = this.buildQuery(1, false);
      const url = `~strategy/transfers/export${
        query ? `?${query}&` : "?"
      }gatewayIds=${this.gatewayId}`;
      const previousResponseType = httpHelper.config.responseType;

      this.isExporting = true;
      httpHelper.config.responseType = "blob";
      httpHelper
        .getData(url)
        .then((res) => {
          this.downloadBlob(res, "transfers.xlsx");
        })
        .then(() => {
          if (previousResponseType) {
            httpHelper.config.responseType = previousResponseType;
          } else {
            delete httpHelper.config.responseType;
          }
          this.isExporting = false;
        });
    },
    clearFilters() {
      this.params.forEach((p) => {
        if (
          p.field === "providerNicknames" ||
          (p.type === "select" && p.multiple)
        ) {
          p.value = [];
          return;
        }
        p.value = null;
      });
      this.filterResetKey += 1;
      this.$nextTick(() => {
        this.loadData(1);
      });
    },
    buildPager(lastPage, currentPage) {
      this.pages = [];
      this.current_page = parseInt(currentPage, 10);
      this.pageNumber = this.current_page;
      this.page_count = lastPage;
      const start = this.current_page > 5 ? this.current_page - 4 : 0;
      let end = lastPage > 5 ? this.current_page + 3 : lastPage;
      if (this.current_page + 3 > this.page_count) {
        end = this.page_count;
      }
      for (let i = start; i < end; i++) {
        this.pages.push(i + 1);
      }
    },
    loadData(page = 1) {
      this.isBusy = true;

      if (this.useMockData) {
        const res = MOCK_TRANSFERS_RESPONSE;
        const list = Array.isArray(res.data) ? res.data : [];
        const total = Number(res.total) || list.length;
        const lastPage = Math.max(1, Math.ceil(total / this.pageSize));
        this.transfers = list;
        this.buildPager(lastPage, page);
        this.isBusy = false;
        this.dataLoaded = true;
        return;
      }

      const url = `~strategy/transfers?${this.buildQuery(page)}&gatewayIds=${
        this.gatewayId
      }`;
      httpHelper
        .getData(url)
        .then((res) => {
          const list = Array.isArray(res && res.data) ? res.data : [];
          const total = Number(res && res.total) || 0;
          const lastPage = Math.max(1, Math.ceil(total / this.pageSize));
          this.transfers = list;
          this.buildPager(lastPage, page);
        })
        .catch(() => {
          this.transfers = [];
          this.buildPager(1, 1);
        })
        .then(() => {
          this.isBusy = false;
          this.dataLoaded = true;
        });
    },
  },
  mounted() {
    this.loadData(1);
  },
};
</script>

<style scoped>
.w-150 {
  width: 150px;
}

.transfer-action-btn {
  color: #6c757d;
}

.transfer-action-btn:hover,
.transfer-action-btn:focus {
  color: #1bc5bd;
  text-decoration: none;
}

.simple-detail-list {
  border: 1px solid #eff2f5;
  border-radius: 8px;
}

.simple-detail-row {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 1rem;
  padding: 0.75rem 1rem;
  border-bottom: 1px solid #eff2f5;
}

.simple-detail-row:last-child {
  border-bottom: none;
}

.simple-detail-label {
  color: #6c757d;
  font-size: 0.9rem;
}

.simple-detail-value {
  flex: 1;
  text-align: left;
  color: #212529;
  font-size: 0.95rem;
  font-weight: 500;
  word-break: break-word;
}
</style>
